import { useMemo, useState } from 'react'

import { toDecimalYear } from '@/pages/ui/utils'

import { LAST_INQUIRY_DATE_TREND_TIMEFRAME_VALUE } from './constants'
import { type InquiryDateTrendCardProps } from './inquiry-date-trend-card'

export type UseInquiryDateTrendCardParams = Pick<InquiryDateTrendCardProps, 'inquiryDateTrendData'>

export const useInquiryDateTrendCard = ({ inquiryDateTrendData }: UseInquiryDateTrendCardParams) => {
  const [currentTimeFrame, setCurrentTimeFrame] = useState(LAST_INQUIRY_DATE_TREND_TIMEFRAME_VALUE)

  const handleChangeTimeFrame = (value: string) => {
    setCurrentTimeFrame(value)
  }

  const inquiryDateMonthlySeries = useMemo(() => {
    if (!inquiryDateTrendData) {
      return null
    }

    return inquiryDateTrendData
      ? inquiryDateTrendData
          .map((item) => ({
            ...item,
            caseInquiryDateInDecimal: item.caseInquiryDate ? toDecimalYear(item.caseInquiryDate) : null,
          }))
          .slice(-parseInt(currentTimeFrame, 10))
      : null
  }, [inquiryDateTrendData, currentTimeFrame])

  return {
    currentTimeFrame,
    inquiryDateMonthlySeries,
    handleChangeTimeFrame,
  }
}
